import styled from 'styled-components';

export const Radio = styled.input.attrs({
  type: 'radio',
})`

`;

export default Radio;
